// extracted by mini-css-extract-plugin
module.exports = {"form":"password-sign-in_form__aFC9Y","submitButton":"password-sign-in_submitButton__kkjn5","forgotPasswordContainer":"password-sign-in_forgotPasswordContainer__DvRO8"};